/**
 * NotExpectingStep - "We get it" screen
 *
 * Shows understanding message and gives options to continue with Catch
 * or cancel the trial.
 */

interface NotExpectingStepProps {
  onContinue: () => void;
  onCancel: () => void;
}

export function NotExpectingStep({ onContinue, onCancel }: NotExpectingStepProps) {
  return (
    <div className="flex flex-col gap-6">
      {/* Header */}
      <h2 className="text-center text-2xl font-bold text-catch-dark-blue-90">We get it</h2>

      {/* Body text */}
      <div className="flex flex-col gap-4 text-center text-catch-slate">
        <p>
          You may have come to Catch expecting a broader view of your health.
        </p>
        <p>
          Today, Catch provides a full cancer risk profile.
        </p>
        <p>
          Heart disease, dementia, and diabetes models are actively in development
          and rolling out next.
        </p>
      </div>

      {/* Continue with Catch CTA */}
      <button
        onClick={onContinue}
        className="flex w-full items-center justify-center rounded-full bg-catch-avocado-400 px-5 py-4 text-sm font-bold text-catch-dark-blue-90 transition-opacity hover:opacity-90"
      >
        Continue with Catch
      </button>

      {/* Cancel trial link */}
      <button
        onClick={onCancel}
        className="w-full text-center text-sm font-medium text-catch-danger transition-opacity hover:opacity-70"
      >
        Cancel my trial
      </button>
    </div>
  );
}

export default NotExpectingStep;
